/**
 * SiteFavicon
 *
 * Loads site_favicon_url from platform_settings and applies it
 * to the browser tab favicon at runtime. No re-render needed.
 * Admin-managed via Settings → Site Identity.
 */
import { useEffect } from 'react';
import { supabase }  from '../lib/supabaseClient';

export default function SiteFavicon() {
  useEffect(() => {
    supabase
      .from('platform_settings')
      .select('value')
      .eq('key', 'site_favicon_url')
      .maybeSingle()
      .then(({ data }) => {
        const url = data?.value?.trim();
        if (!url) return;
        // Update existing <link rel="icon"> or create one
        let link = document.querySelector("link[rel~='icon']");
        if (!link) {
          link = document.createElement('link');
          link.rel = 'icon';
          document.head.appendChild(link);
        }
        link.href = url;
      })
      .catch(() => {});
  }, []);

  return null;
}
